// apiServiceHelper.jsx
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { Auth } from "aws-amplify";
import config from "../aws-exports";
import { v4 as uuidv4 } from "uuid";
//import AWS from 'aws-sdk';
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client, HeadObjectCommand } from "@aws-sdk/client-s3";

export const userData = async () => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });
  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  return user.attributes;
};
const getBackendName = () => {
  const backend = config.aws_user_files_s3_bucket.split("-");
  return backend[backend.length - 1];
};
export const searchfetchQueries = async (
  data = {},
  functionType = "dataops"
) => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });
  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;
  const body = {
    ...data,
  };
  const params = {
    FunctionName: `dataops-${getBackendName()}`,
    // FunctionName: `${functionType}-${process.env.REACT_APP_BACKEND}`,
    Payload: JSON.stringify({ body }),
  };

  try {
    const command = new InvokeCommand(params);
    const data = await lambdaClient.send(command);
    let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result.items; // Return the items
    } else {
      console.error("Error: ", result);
      throw new Error("Error invoking Lambda function");
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", error);
    throw error;
  }
};

export const fetchData = async (data = {}) => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });
  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;
  const body = {
    ...data,
  };
  const params = {
    FunctionName: `dataops-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };

  try {
    const command = new InvokeCommand(params);
    const data = await lambdaClient.send(command);
    let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result; // Return the items
    } else {
      console.error("Error: ", result);
      throw new Error("Error invoking Lambda function");
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", error);
    throw error;
  }
};

export const fetchQueries = async (
  userOrder = "CreatedOn",
  rowStart = 0,
  pageSize = 10
) => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });

  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  const body = {
    access_token: user.signInUserSession.idToken.jwtToken,
    target: "listGroupMaster",
    userOrder: userOrder,
    rowStart: rowStart,
    pageSize: pageSize,
  };

  const params = {
    FunctionName: `dataops-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };

  try {
    const command = new InvokeCommand(params);
    const data = await lambdaClient.send(command);
    let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result.items; // Return the items
    } else {
      console.error("Error: ", result);
      throw new Error("Error invoking Lambda function");
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", error);
    throw error;
  }
};
// Post request function
export const postQuery = async (data = {}, functionType = "dataops") => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });

  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;

  let body = {
    ...data,
  };
  const params = {
    FunctionName: `${functionType}-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };
  let result = "";
  try {
    const command = new InvokeCommand(params);
    const dataResponse = await lambdaClient.send(command);
    result = JSON.parse(new TextDecoder("utf-8").decode(dataResponse.Payload));

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result; // Return the result from the POST request
    } else {
      console.log("invoke");
      result = JSON.parse(result.body);
      //return result;
      throw new Error(result);
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", result);
    throw result;
  }
};
//Get by ID
export const getQuery = async (data = "") => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });
  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;
  let body = {
    ...data,
  };
  const params = {
    FunctionName: `dataops-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };

  try {
    const command = new InvokeCommand(params);
    const data = await lambdaClient.send(command);
    let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result.items; // Return the items
    } else {
      throw new Error("Error invoking Lambda function");
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", error);
    throw error;
  }
};

export const updateQuery = async (data = {}) => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });

  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;

  console.log(data);
  let body = {
    ...data,
  };
  console.log(body);
  const params = {
    FunctionName: `dataops-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };

  let result = "";
  try {
    const command = new InvokeCommand(params);
    const dataResponse = await lambdaClient.send(command);
    let result = JSON.parse(
      new TextDecoder("utf-8").decode(dataResponse.Payload)
    );

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result; // Return the result from the POST request
    } else {
      console.log("invoke");
      result = JSON.parse(result.body);
      //return result;
      throw new Error(result);
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", result);
    throw result;
  }
};
export const uploadFileToS3 = async (file) => {
  try {
    const sanitizeFileName = (name) => {
      return name.replace(/\s+/g, "_"); // Replace spaces with underscores
    };
    const credentials = await Auth.currentCredentials();
    const essentialCreds = Auth.essentialCredentials(credentials);
    const s3Client = new S3Client({
      region: config.aws_project_region,
      credentials: {
        accessKeyId: essentialCreds.accessKeyId,
        secretAccessKey: essentialCreds.secretAccessKey,
        sessionToken: essentialCreds.sessionToken,
      },
    });
    const folder = "public/images";
    const bucket = process.env.REACT_APP_AMTPL_BUCKET;
    const sanitizedFileName = sanitizeFileName(file.name);
    const uniqueFileName = `${uuidv4()}_${sanitizedFileName}`;
    const filePath = `${folder}/${uniqueFileName}`;
    const parallelUpload = new Upload({
      client: s3Client,
      params: {
        Bucket: bucket,
        Key: filePath,
        Body: file,
        ContentType: file.type || "application/octet-stream",
      },
      leavePartsOnError: false,
    });
    parallelUpload.on("httpUploadProgress", (progress) => {
      console.log("Upload Progress:", progress);
    });
    await parallelUpload.done();
    const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;
    return {
      url: fileUrl,
      fileName: uniqueFileName,
    };
  } catch (e) {
    console.error("Upload Error:", e);
    throw new Error("Upload to S3 failed: " + e.message);
  }
};
export const getFileFromS3 = async (file) => {
  const folder = "public/images";
  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  const filePath = `${folder}/${file}`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;
  return fileUrl;
};

export const uploadVideoToS3 = async (file, visibility = "public") => {
  try {
    // Check if file is a valid File object
    if (!(file instanceof File)) {
      console.warn("Invalid file object provided");
      return { fileName: file?.name || "Invalid file" };
    }
    const credentials = await Auth.currentCredentials();
    const essentialCreds = Auth.essentialCredentials(credentials);

    const sanitizeFileName = (name) => {
      return name.replace(/\s+/g, "_"); // Replace spaces with underscores
    };

    const s3Client = new S3Client({
      region: config.aws_project_region,
      credentials: {
        accessKeyId: essentialCreds.accessKeyId,
        secretAccessKey: essentialCreds.secretAccessKey,
        sessionToken: essentialCreds.sessionToken,
      },
    });
    // Use private folder if visibility is "private", otherwise use public/media/amtpl
    const folder = visibility === "private" ? "private" : "public/media/amtpl";
    const bucket = process.env.REACT_APP_AMTPL_BUCKET;
    const sanitizedFileName = sanitizeFileName(file.name);
    const uniqueFileName = `${uuidv4()}_${sanitizedFileName}`;
    const filePath = `${folder}/${uniqueFileName}`;
    const filePathExist = `${folder}/${file?.name}`;
    console.log("File Path:", filePath, "Visibility:", visibility);

    // Check if file already exists in S3
    try {
      await s3Client.send(
        new HeadObjectCommand({
          Bucket: bucket,
          Key: filePathExist,
        })
      );
      // If the file exists, return the file name
      console.warn("File already exists in S3");
      return { fileName: file?.name };
    } catch (error) {
      // If error code is 'NotFound', proceed with upload; otherwise, throw error
      /*  if (error.name !== 'NotFound') {
        throw new Error('Error checking file existence: ' + error.message);
      } */
    }

    const parallelUpload = new Upload({
      client: s3Client,
      params: {
        Bucket: bucket,
        Key: filePath,
        Body: file,
        ContentType: file.type || "application/octet-stream",
      },
      leavePartsOnError: false,
    });

    parallelUpload.on("httpUploadProgress", (progress) => {
      console.log("Upload Progress:", progress);
    });

    await parallelUpload.done();

    const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

    return {
      url: fileUrl,
      fileName: uniqueFileName,
    };
  } catch (e) {
    console.error("Upload Error:", e);
    throw new Error("Upload to S3 failed: " + e.message);
  }
};

export const uploadFileToS3Path = async (file, folderpath) => {
  try {
    const sanitizeFileName = (name) => {
      return name.replace(/\s+/g, "_"); // Replace spaces with underscores
    };
    const credentials = await Auth.currentCredentials();
    const essentialCreds = Auth.essentialCredentials(credentials);
    const s3Client = new S3Client({
      region: config.aws_project_region,
      credentials: {
        accessKeyId: essentialCreds.accessKeyId,
        secretAccessKey: essentialCreds.secretAccessKey,
        sessionToken: essentialCreds.sessionToken,
      },
    });
    // const folder = "public/images";
    const folder = folderpath;
    const bucket = process.env.REACT_APP_AMTPL_BUCKET;
    const sanitizedFileName = sanitizeFileName(file.name);
    const uniqueFileName = `${uuidv4()}_${sanitizedFileName}`;
    const filePath = `${folder}/${uniqueFileName}`;
    const parallelUpload = new Upload({
      client: s3Client,
      params: {
        Bucket: bucket,
        Key: filePath,
        Body: file,
        ContentType: file.type || "application/octet-stream",
      },
      leavePartsOnError: false,
    });
    parallelUpload.on("httpUploadProgress", (progress) => {
      console.log("Upload Progress:", progress);
    });
    await parallelUpload.done();
    const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;
    return {
      url: fileUrl,
      fileName: uniqueFileName,
    };
  } catch (e) {
    console.error("Upload Error:", e);
    throw new Error("Upload to S3 failed: " + e.message);
  }
};
// Post request function
export const postQueryBackendopsFun = async (
  data = {},
  functionType = "backendops"
) => {
  const credentials = await Auth.currentCredentials();
  const lambdaClient = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: config.aws_project_region,
  });

  const user = await Auth.currentAuthenticatedUser({
    bypassCache: true,
  });
  data.access_token = user.signInUserSession.idToken.jwtToken;

  let body = {
    ...data,
  };
  const params = {
    FunctionName: `${functionType}-${getBackendName()}`,
    Payload: JSON.stringify({ body }),
  };
  let result = "";
  try {
    const command = new InvokeCommand(params);
    const dataResponse = await lambdaClient.send(command);
    result = JSON.parse(new TextDecoder("utf-8").decode(dataResponse.Payload));

    console.log("BS result@@@@", result);

    if (result.statusCode === 200) {
      result = JSON.parse(result.body);
      return result; // Return the result from the POST request
    } else {
      console.log("invoke");
      result = JSON.parse(result.body);
      //return result;
      throw new Error(result);
    }
  } catch (error) {
    console.error("Error invoking Lambda function: ", result);
    throw result;
  }
};
// ============================================
// Currency Conversion Service
// ============================================

// Singleton to store currency rates in memory
let cachedCurrencyRates = null;

/**
 * Fetch currency rates from backend
 * @returns {Promise<Object>} Currency rates object
 */
export const getCurrencyRates = async () => {
  try {
    const body = {
      target: "getCurrencyRates",
    };
    const result = await fetchData(body);

    if (result && (result.rates || result.statusCode === 200)) {
      cachedCurrencyRates = result.rates[0];
      console.log("Currency Rates Loaded:", cachedCurrencyRates);
      return cachedCurrencyRates;
    } else {
      console.error("Error fetching currency rates:", result);
      return null;
    }
  } catch (error) {
    console.error("Error fetching currency rates:", error);
    return null;
  }
};

/**
 * Get cached currency rates (useful for React hooks)
 * @returns {Object|null} Cached currency rates or null
 */
export const getCachedCurrencyRates = () => {
  return cachedCurrencyRates;
};

/**
 * Convert amount from base currency (USD) to target currency
 * @param {number} amount - Amount in base currency (USD)
 * @param {string} toCurrency - Target currency code (e.g., 'INR', 'EUR')
 * @param {Object} rates - Optional: Currency rates object. If not provided, uses cached rates
 * @returns {number} Converted amount
 */
export const convertToCurrency = (amount, toCurrency, rates = null) => {
  const currencyRates = rates || cachedCurrencyRates;

  if (!currencyRates) {
    console.error(
      "Currency rates not loaded. Please call getCurrencyRates() first."
    );
    return amount;
  }

  if (!currencyRates[toCurrency]) {
    console.error(`Currency rate not available for: ${toCurrency}`);
    return amount;
  }

  const convertedAmount = amount * currencyRates[toCurrency];
  return convertedAmount;
};

/**
 * Convert amount from target currency to base currency (USD)
 * @param {number} amount - Amount in target currency
 * @param {string} fromCurrency - Source currency code (e.g., 'INR', 'EUR')
 * @param {Object} rates - Optional: Currency rates object. If not provided, uses cached rates
 * @returns {number} Converted amount in base currency (USD)
 */
export const convertToBaseCurrency = (amount, fromCurrency, rates = null) => {
  const currencyRates = rates || cachedCurrencyRates;

  if (!currencyRates) {
    console.error(
      "Currency rates not loaded. Please call getCurrencyRates() first."
    );
    return amount;
  }

  if (!currencyRates[fromCurrency]) {
    console.error(`Currency rate not available for: ${fromCurrency}`);
    return amount;
  }

  const convertedAmount = amount / currencyRates[fromCurrency];
  return convertedAmount;
};

export const formatData = (data) => {
  if (data === null || data === undefined || data === "") return "0.00";
  const numValue = parseFloat(data);
  return isNaN(numValue) ? "0.00" : numValue.toFixed(2);
};

/**
 * Convert amount from one currency to another
 * @param {number} amount - Amount to convert
 * @param {string} fromCurrency - Source currency code
 * @param {string} toCurrency - Target currency code
 * @param {Object} rates - Optional: Currency rates object. If not provided, uses cached rates
 * @returns {number} Converted amount
 */
export const convertBetweenCurrencies = (
  amount,
  fromCurrency,
  toCurrency,
  rates = null
) => {
  // First convert to base currency (USD), then to target currency
  const baseAmount = convertToBaseCurrency(amount, fromCurrency, rates);
  return convertToCurrency(baseAmount, toCurrency, rates);
};
